import React from 'react'
import PropTypes from 'prop-types'
import Markdown from 'markdown-to-jsx'

// Styles
import styles from './CompanyDisclaimer.module.scss'

const propTypes = {
  disclaimer: PropTypes.string
}

const CompanyDisclaimer = ({ disclaimer }) => (
  <div className={styles.disclaimer}>
    <Markdown className={styles.disclaimerBody}>{disclaimer}</Markdown>
  </div>
)

CompanyDisclaimer.propTypes = propTypes

export default CompanyDisclaimer
